import moment from "moment";
import { useEffect, useState } from "react";
import { API_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import calendar from "../../img/calendar.png";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import { FiArrowRight, FiDownload, FiLock, FiCalendar, FiClock, FiZap, FiArrowUpRight } from "react-icons/fi";
import { FaStar, FaInstagram, FaYoutube, FaGlobe, FaLinkedin, FaFacebook } from "react-icons/fa";

import "./ServiceCardThemeV7.css";

moment.locale("en");

// Calendar Component
function MonthGridCalendar({ slots, packageDays, selectedValue, onSelect }) {
  const today = moment().locale("en");
  const [viewMonth, setViewMonth] = useState(today.clone().startOf("month"));

  const availableSet = new Set((slots || []).filter((s) => s.available).map((s) => s.value));
  const slotMap = {};
  (slots || []).forEach((s) => { slotMap[s.value] = s; });

  const goMonth = (dir) => setViewMonth((prev) => prev.clone().locale("en").add(dir, "month").startOf("month"));
  
  const vmEn = viewMonth.clone().locale("en");
  const startDay = vmEn.clone().startOf("month").day();
  const daysInMonth = vmEn.daysInMonth();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const isPrevDisabled = viewMonth.clone().locale("en").isSameOrBefore(today.clone().startOf("month"));

  return (
    <div>
      <div className="monthNavRow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <button type="button" onClick={() => goMonth(-1)} disabled={isPrevDisabled} style={{ background: 'none', border: 'none', cursor: isPrevDisabled ? 'not-allowed' : 'pointer', fontSize: '18px', color: 'var(--v7-muted)' }}>‹</button>
        <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--v7-text)' }}>{vmEn.format("MMMM YYYY")}</h4>
        <button type="button" onClick={() => goMonth(1)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: 'var(--v7-muted)' }}>›</button>
      </div>
      <table className="monthGridCalendar" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
        <thead>
          <tr>{DOW.map((d) => (<th key={d} style={{ padding: '8px 0', fontSize: '12px', opacity: 0.7 }}>{d}</th>))}</tr>
        </thead>
        <tbody>
          {weeks.map((week, wi) => (
            <tr key={wi}>
              {week.map((day, di) => {
                if (!day) return <td key={di}><div style={{ padding: '8px' }}></div></td>;
                const dateVal = vmEn.clone().date(day).format("YYYY/MM/DD");
                const isPast = vmEn.clone().date(day).isBefore(today, "day");
                const dayMatches = packageDays.length === 0 || packageDays.includes(moment(dateVal, "YYYY/MM/DD").locale("en").format("ddd").toUpperCase());
                const isAvail = availableSet.has(dateVal) && !isPast && dayMatches;
                const isSelected = selectedValue === dateVal;
                
                let btnClass = "gridDayBtn ";
                if(isSelected) btnClass += "gridSelected";
                else if(isAvail) btnClass += "gridAvailable";
                
                return (
                  <td key={di} style={{ padding: '4px' }}>
                    <button
                      type="button"
                      className={btnClass}
                      style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', cursor: isAvail ? 'pointer' : 'not-allowed', opacity: isAvail || isSelected ? 1 : 0.3 }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isAvail) return;
                        const slotObj = slotMap[dateVal];
                        if (slotObj) onSelect(slotObj);
                      }}
                    >
                      {day}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Time Panel Component
function TimeSidePanel({ hasDateSelected, slots, selectedSlot, onSelect, isDisabledFn }) {
  return (
    <div className="timeSide">
      <div className="v7-section-eyebrow" style={{ marginBottom: '16px' }}>
        <FiClock size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
        Select Time
      </div>
      {!hasDateSelected ? (
        <div style={{ opacity: 0.5, fontSize: '13px', fontWeight: 600 }}>Pick a date to see times</div>
      ) : (
        <div className="v7-twoColSlots">
          {slots.length > 0 ? (
            slots.map((item, i) => {
              const fromStr = item.from ?? "";
              const toStr = item.to ?? "";
              const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
              const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
              const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
              const isSelected = selectedSlot?.from === fromStr && selectedSlot?.to === toStr;
              const isDisabled = isDisabledFn ? isDisabledFn(item) : false;
              
              return (
                <button
                  type="button"
                  key={i}
                  className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                  style={{ padding: '12px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                  onClick={(e) => { e.preventDefault(); if (!isDisabled) onSelect(item); }}
                >
                  {displayFrom} – {displayTo}
                </button>
              );
            })
          ) : (
            <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 600 }}>No slots available</p>
          )}
        </div>
      )}
    </div>
  );
}

// Main Component
const ServiceCardThemeV7 = ({
  data,
  selectService,
  isPreview,
  uploadDetails,
  updateState,
  confirmDetails,
  recaptcha,
  viewAvailableSlot,
  slugSelected,
  onResourceClick,
}) => {
  
  const eventData = data.eventData || data.eventDetails || {};
  const userDetails = data.userDetails || {};
  const resourceList = data.resource || data.resourceList || [];
  
  const businessLogo = isPreview 
    ? eventData.businessLogo 
    : eventData.businessLogo ? `${API_URL}auth/image/${eventData.businessLogo}` : calendar;
    
  const businessName = eventData.businessName || userDetails.userName || "Arjun Mehta";
  
  // Custom parsing for the title to implement the neon green highlight on specific words if it matches default
  const defaultTitle = "BUILD WHAT MOVES YOU.";
  const displayTitle = eventData.serviceName || defaultTitle;
  
  const renderHeroTitle = (title) => {
    if (title.toUpperCase() === defaultTitle.toUpperCase()) {
      return <>BUILD <br/> WHAT <span style={{ color: 'var(--v7-neon)' }}>MOVES</span> <br/> YOU.</>;
    }
    return title.toUpperCase();
  };

  const rawReviews = data.reviewList || [];
  const dummyReviews = [
    { name: "Simran J.", source: "Google", suggestion: "A training plan with structure, without losing the fun.", satisfaction: 5 },
    { name: "Karthik A.", source: "Featured review", suggestion: "The rare class that feels both hard and welcoming.", satisfaction: 5 },
    { name: "Neha P.", source: "Google", suggestion: "Recovery finally feels like part of my progress.", satisfaction: 5 }
  ];
  const reviews = rawReviews.length > 0 ? rawReviews : dummyReviews;
  const avgRating = eventData.ratings ?? "4.9/5";

  const dummyServices = [
    { serviceName: "Foundation", duration: 60, amount: 2200, appointmentName: "INDIVIDUAL COACHING", description: "A tailored session with clear movement cues and progression." },
    { serviceName: "Run stronger", duration: 75, amount: 2600, appointmentName: "SMALL GROUP CLASS", description: "Train alongside a close cohort while keeping coaching specific." },
    { serviceName: "Race ready", duration: 90, amount: 3100, appointmentName: "INDIVIDUAL COACHING", description: "A detailed session for strength, recovery and a sustainable plan." }
  ];
  const rawServiceList = data.service || data.serviceList || [];
  const serviceList = rawServiceList.length > 0 ? rawServiceList : dummyServices;

  const [chosenService, setChosenService] = useState(null);
  const [isPackageSelected, setIsPackageSelected] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedNoteOption, setSelectedNoteOption] = useState(""); // Track the dropdown selection
  const isMobile = window.screen.width < 768;

  useEffect(() => {
    if (!slugSelected || !serviceList.length) return;
    const index = serviceList.findIndex((s) => s.slug === slugSelected || String(s.id) === String(slugSelected));
    if (index !== -1) handleBookClick(serviceList[index], index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugSelected, serviceList]);

  // FIX 2: close the modal automatically once a booking completes.
  // The free-booking flow never toggled isModalOpen (it's local state here),
  // so the modal stayed open after a free booking succeeded. The parent
  // (CalendarVcard) flips data.bookingSuccess to true on both the free and
  // paid success paths — this effect reacts to that signal.
  useEffect(() => {
    if (data.bookingSuccess) {
      setIsModalOpen(false);
    }
  }, [data.bookingSuccess]);

  const safeParse = (value) => {
    try {
      if (!value) return [];
      const p = JSON.parse(value);
      return typeof p === "string" ? JSON.parse(p) : p;
    } catch (e) { return []; }
  };

  const packageDays = safeParse(isPackageSelected?.packageDays);
  const timeSlots = safeParse(isPackageSelected?.timeSlots) || [];

  const getAllSlots = () => {
    if (!data.availableSlot?.length) return [];
    return data.availableSlot.filter((item) => {
      if (Object.keys(data?.activeIndexData || {}).length > 0) {
        const isToday = moment(data.activeIndexData.value, "YYYY/MM/DD");
        if (isToday.isSame(moment(), "day")) {
          const curTime = moment(new Date(), "HH:mm");
          const fromTime = moment(item.from, "HH:mm");
          return fromTime.isSameOrAfter(curTime);
        }
      }
      return true;
    });
  };

  const priceLabel = (svc) => (svc?.amount == 0 ? "Free" : `₹${svc?.amount}`);
  const selectedServiceObj = chosenService !== null ? serviceList[chosenService] : null;

  const handleBookClick = (item, ind) => {
    selectService(item);
    setChosenService(ind);
    setIsPackageSelected(item);
    updateState("bookingMode", "self");
    updateState("expertNote", "");
    updateState("bookingSuccess", false); // FIX 2: clear any stale success flag from a previous booking
    setIsModalOpen(true);
  };

  const handleResourceCardClick = (res) => {
    if (isPreview) return;
    if (typeof onResourceClick === "function") onResourceClick(res);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    updateState("name", "");
    updateState("email", "");
    updateState("phoneNumber", "");
    updateState("description", "");
    updateState("detailsPage", false); // Reset back to step 1
    updateState("bookingSuccess", false); // FIX 2: keep state clean on manual close too
    setSelectedNoteOption(""); // Reset dropdown selection

    if (recaptcha?.current) {
      recaptcha.current.reset();
    }
  };

  // V7 Step Indicator
  const renderStepper = (activeStep) => (
    <div className="v7-bkStepBar">
      <div className={`v7-bkStep ${activeStep === 1 ? "active" : activeStep > 1 ? "done" : ""}`}>
        <div className="v7-bkStepCircle">{activeStep > 1 ? "✓" : "1"}</div>
        <span>Choose option</span>
      </div>
      <div className={`v7-bkStepLine ${activeStep > 1 ? "done" : ""}`} />
      <div className={`v7-bkStep ${activeStep === 2 ? "active" : activeStep > 2 ? "done" : ""}`}>
        <div className="v7-bkStepCircle">{activeStep > 2 ? "✓" : "2"}</div>
        <span>Provide details</span>
      </div>
      <div className={`v7-bkStepLine ${activeStep > 2 ? "done" : ""}`} />
      <div className={`v7-bkStep ${activeStep === 3 ? "active" : ""}`}>
        <div className="v7-bkStepCircle">3</div>
        <span>Confirmation</span>
      </div>
    </div>
  );

  // Modal Booking Flow
  const renderBookingModal = () => {
    if (!isModalOpen || chosenService === null) return null;
    const isGroupPackage = ["group_package", "one_to_one_package"].includes(isPackageSelected?.appointmentName);
    
    return (
      <div className="v7-modal-overlay" onClick={closeModal}>
        <div className="v7-modal-content" onClick={(e) => e.stopPropagation()}>
          <button type="button" className="v7-modal-close" onClick={closeModal}>×</button>
          
          {data.detailsPage ? (
            <form onSubmit={(e) => { e.preventDefault(); uploadDetails(e); }} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {renderStepper(2)}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
                <h4 className="v7-section-title" style={{ margin: 0, fontSize: '24px' }}>Provide Details</h4>
                <button type="button" onClick={() => { recaptcha?.current?.reset(); updateState("detailsPage", false); }} className="v7-btn-outline" style={{ border: 'none' }}>
                  ← Back
                </button>
              </div>
              
              <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:700, textTransform:'uppercase', color:'var(--v7-muted)' }}>Name *</label>
                <input className="input-text-input" value={data.name} type="text" placeholder="ENTER NAME" required onChange={(e) => updateState("name", e.target.value)} />
              </div>
              <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:700, textTransform:'uppercase', color:'var(--v7-muted)' }}>Email *</label>
                <input className="input-text-input" value={data.email} type="email" placeholder="ENTER EMAIL" required onChange={(e) => updateState("email", e.target.value?.trim())} />
              </div>
               <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Phone Number *</label>
                <div style={{ marginTop: "4px" }}>
                  <PhoneInput
                    country={"in"}
                    containerClass="input-dark"
                    value={data.phoneNumber}
                    placeholder=""
                    countryCodeEditable={false}
                    onChange={(phone) => updateState("phoneNumber", phone)}
                    required
                  />
                </div>
              </div>
                 <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Notes for preparation *</label>
                <select 
                  className="input-text-input" 
                  value={selectedNoteOption}
                  required
                  onChange={(e) => {
                    setSelectedNoteOption(e.target.value);
                    if (e.target.value !== "Other") {
                      updateState("description", e.target.value);
                    } else {
                      updateState("description", "");
                    }
                  }}
                  style={{ marginBottom: selectedNoteOption === "Other" ? '12px' : '0' }}
                >
                  <option value="" disabled>Select an option</option>
                  <option value="I'm looking for general relaxation and mindfulness.">I'm looking for general relaxation and mindfulness.</option>
                  <option value="I'm dealing with specific tension/tightness and need relief.">I'm dealing with specific tension/tightness and need relief.</option>
                  <option value="I'm a beginner looking for a gentle introduction.">I'm a beginner looking for a gentle introduction.</option>
                  <option value="Other">Other (I will type my own notes)</option>
                </select>

                {selectedNoteOption === "Other" && (
                  <textarea 
                    className="input-text-input" 
                    value={data.description} 
                    required={selectedNoteOption === "Other"} 
                    placeholder="Please specify your requirements or notes here..."
                    onChange={(e) => updateState("description", e.target.value)} 
                    style={{ minHeight: '100px', resize: 'vertical' }} 
                  />
                )}
              </div>
              
              <div style={{ margin: "8px 0" }}>
                <ReCAPTCHA size={isMobile ? "compact" : "normal"} ref={recaptcha} sitekey={REACT_APP_SITE_KEY} />
              </div>
              
              <button type="submit" className="v7-btn-primary" onClick={() => confirmDetails()} style={{ alignSelf: 'flex-start' }}>
                <FiCalendar size={16}/> Book {selectedServiceObj?.serviceName} - {priceLabel(selectedServiceObj)} <FiArrowRight size={16} />
              </button>
            </form>
          ) : (
            <div>
              {renderStepper(1)}
              
              {!isGroupPackage && (
                <>
                  <div style={{ marginBottom: '32px', textAlign: 'center' }}>
                    <h2 className="v7-section-title" style={{ fontSize: '32px', marginBottom: '8px' }}>
                      Schedule your session
                    </h2>
                    <p style={{ opacity: 0.6, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', fontSize: '13px', color: 'var(--v7-neon)' }}>
                      Choose how you&apos;d like to book
                    </p>
                  </div>
                  
                  <div className="v7-bkModeRow">
                    <div className={`v7-bkModeCard ${data.bookingMode === "self" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "self")}>
                      <div className="v7-bkModeRadio">{data.bookingMode === "self" && <div className="v7-bkModeRadioInner" />}</div>
                      <div className="v7-bkModeText">
                        <h5>I&apos;ll pick date & time</h5>
                        <p>Select from available slots</p>
                      </div>
                    </div>
                    
                    <div className={`v7-bkModeCard ${data.bookingMode === "expert" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "expert")}>
                      <div className="v7-bkModeRadio">{data.bookingMode === "expert" && <div className="v7-bkModeRadioInner" />}</div>
                      <div className="v7-bkModeText">
                        <h5>Let the expert choose</h5>
                        <p>Share your preference and expert will schedule</p>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {data.bookingMode === "expert" && !isGroupPackage && (
                <div style={{ padding: '32px', background: 'var(--v7-card)', border: '1px solid var(--v7-border)', marginBottom: '32px' }}>
                  <label style={{ display:'block', marginBottom:'16px', fontSize:'14px', fontWeight:800, textTransform: 'uppercase', color: 'var(--v7-neon)' }}>Share your preference / availability</label>
                  <textarea 
                    className="input-text-input"
                    placeholder="e.g. I'm available weekday evenings after 6 PM IST, prefer Thursday or Friday..."
                    value={data.expertNote || ""}
                    onChange={(e) => updateState("expertNote", e.target.value)}
                    style={{ minHeight: '120px', marginBottom: '16px' }}
                  />
                  <p style={{ fontSize: '13px', opacity: 0.7, fontWeight: 600 }}>The expert will review your preference and send you a confirmed slot via email.</p>
                </div>
              )}

              {(data.bookingMode === "self" || isGroupPackage) && (
                <div className="v7-calTimeSplit">
                  <div className="v7-calSide">
                    <div className="v7-section-eyebrow" style={{ marginBottom: '16px' }}>
                      <FiCalendar size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                      Select Date
                    </div>
                    <MonthGridCalendar
                      slots={data.slots}
                      packageDays={isGroupPackage ? packageDays : []}
                      selectedValue={data.activeIndexData?.value}
                      onSelect={(slotObj) => {
                        const idx = data.slots?.findIndex((s) => s.value === slotObj.value);
                        viewAvailableSlot(idx ?? 0, slotObj, slotObj.available);
                      }}
                    />
                  </div>
                  
                  <div className="v7-timeSide">
                    {data.activeIndexData?.value && (
                      <div className="v7-tzChip">
                        <FiClock size={14} style={{ marginRight:'4px' }} /> {eventData.timeZone ? `Times in ${eventData.timeZone}` : "Times in IST"}
                      </div>
                    )}
                    
                    {!data.activeIndexData?.value ? (
                      <div style={{ padding: '60px 20px', textAlign: 'center', opacity: 0.4, border: '1px solid var(--v7-border)', background: 'var(--v7-card)' }}>
                        <FiCalendar size={40} style={{ marginBottom: '16px' }} />
                        <p style={{ fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>No date selected<br/><span style={{ opacity: 0.7, fontWeight: 500, fontSize: '12px' }}>Pick a date on the left</span></p>
                      </div>
                    ) : (
                      <div className="v7-twoColSlots">
                        {(isGroupPackage ? timeSlots : getAllSlots()).length > 0 ? (
                          (isGroupPackage ? timeSlots : getAllSlots()).map((item, i) => {
                            const fromStr = item.from ?? "";
                            const toStr = item.to ?? "";
                            const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
                            const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
                            const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
                            const isSelected = data.selectedSlot?.from === fromStr && data.selectedSlot?.to === toStr;
                            const isDisabled = item.slotAvailable === false;
                            
                            return (
                              <button
                                type="button"
                                key={i}
                                className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                                style={{ padding: '14px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1, textTransform: 'uppercase', letterSpacing: '1px' }}
                                onClick={(e) => { 
                                  e.preventDefault(); 
                                  if (!isDisabled) {
                                    updateState("slotActiveIndex", isGroupPackage ? i : getAllSlots().findIndex(s => s.from === item.from));
                                    updateState("selectedSlot", item);
                                  } 
                                }}
                              >
                                {displayFrom} – {displayTo}
                              </button>
                            );
                          })
                        ) : (
                          <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 700, textTransform: 'uppercase', color: 'var(--v7-neon)' }}>No slots available</p>
                        )}
                      </div>
                    )}

                    {!isGroupPackage && data.activeIndexData?.value && (
                       <div style={{ display: 'flex', gap: '16px', padding: '24px', background: 'var(--v7-card)', border: '1px solid var(--v7-border)', marginTop: '24px' }}>
                         <FiZap size={20} color="var(--v7-neon)" style={{ flexShrink: 0 }} />
                         <div>
                           <h6 style={{ fontSize: '14px', fontWeight: 800, marginBottom: '8px', textTransform: 'uppercase', color: 'var(--v7-neon)' }}>Instant confirmation</h6>
                           <p style={{ fontSize: '13px', opacity: 0.7, lineHeight: 1.5, fontWeight: 500 }}>Your session will be confirmed immediately after booking.</p>
                         </div>
                       </div>
                    )}
                  </div>
                </div>
              )}

              <div style={{ marginTop: '48px', display: 'flex', justifyContent: 'center' }}>
                <button 
                   type="button" 
                   className="v7-btn-primary" 
                   style={{ width: '100%', maxWidth: '400px', justifyContent: 'center' }}
                   onClick={() => isPreview ? () => {} : confirmDetails()}
                >
                  Continue to Details <FiArrowRight size={18} />
                </button>
              </div>

            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="v7-wrapper">
      <div className="v7-container">
        
        {/* Navigation */}
        <header className="v7-header">
          <div className="v7-logo-group">
            <span className="v7-logo-circle">
               {businessLogo && businessLogo !== calendar ? (
                 <img src={businessLogo} alt="Logo" />
               ) : (
                 businessName.charAt(0).toUpperCase() + (businessName.split(' ')[1]?.charAt(0).toUpperCase() || "")
               )}
            </span>
            <span>{businessName.toUpperCase()} | COACH</span>
          </div>
          <div>MOVE WITH INTENT</div>
        </header>

        {/* Hero Area Split Background */}
        <section className="v7-hero-split">
          <div className="v7-hero-left">
            <div className="v7-hero-eyebrow">{eventData.sliderTextOne || "PERSONAL PERFORMANCE COACHING"}</div>
            <h1 className="v7-hero-title">
              {renderHeroTitle(displayTitle)}
            </h1>
            <div className="v7-hero-desc" dangerouslySetInnerHTML={{__html: eventData.description || "Strength plans for people who want to get measurably better — without losing the joy of training." }} />
            {/* FIX 1: scrollIntoView instead of offsetTop-based scrollTo — offsetTop
                is relative to the nearest positioned ancestor, not the page, so any
                positioned ancestor in the tree (e.g. the modal overlay) makes it
                resolve to 0 or the wrong offset. scrollIntoView always targets the
                real element regardless of ancestor positioning. */}
            <button
              type="button"
              className="v7-btn-primary"
              onClick={() =>
                document
                  .querySelector('.v7-services-wrapper')
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            >
              Start training <FiArrowUpRight size={16} />
            </button>
          </div>
          
          <div className="v7-hero-right">
            <div className="v7-hero-visual-wrapper">
              <div className="v7-hero-neon-frame"></div>
              {businessLogo && businessLogo !== calendar ? (
                 <div className="v7-hero-image" style={{ backgroundImage: `url(${businessLogo})` }}></div>
              ) : (
                 <div className="v7-hero-image" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=600')` }}></div>
              )}
              <div className="v7-stat-box">
                <div className="v7-stat-label">12-Week Focus</div>
                <div className="v7-stat-value">72% · capacity built</div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Wrapper */}
        <div className="v7-services-wrapper" id="services-section">
          <div className="v7-services-grid">
            {serviceList.map((item, ind) => {
              return (
                <div key={ind} className="v7-service-card">
                  <div className="v7-service-index">0{ind + 1}</div>
                  <h3 className="v7-service-name">{item.serviceName}</h3>
                  <div className="v7-service-price">
                    {item.duration} min · {priceLabel(item)}
                  </div>
                  <div className="v7-service-type">
                    {item.appointmentName?.replace(/_/g, ' ').toUpperCase() || "INDIVIDUAL COACHING"}
                  </div>
                  <p className="v7-service-desc">{item.description}</p>
                  <button type="button" className="v7-btn-outline" onClick={() => handleBookClick(item, ind)}>
                    {item.btnText || "Book this session →"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Single Testimonial Banner */}
        {reviews.length > 0 && (
          <div className="v7-testimonial-banner">
            <div className="v7-banner-stars">
              {Array.from({ length: Math.round(reviews[0]?.satisfaction || 5) }).map((_, i) => (
                 <FaStar key={i} size={16} color="var(--v7-neon)" />
              ))}
            </div>
            <div className="v7-banner-quote">
              “{reviews[0]?.suggestion && reviews[0].suggestion !== "Not given" ? reviews[0].suggestion : "Arjun's plan gave structure to my training without making it joyless."}”
            </div>
            <div className="v7-banner-author">
               {reviews[0]?.name || "Simran J."} · {reviews[0]?.source || "featured client review"}
            </div>
          </div>
        )}

        {/* Ready-Made Resources Section */}
        {resourceList.length > 0 && (
          <section className="v7-notes-section" id="resources-section">
            <div className="v7-notes-header">
              <div>
                <div className="v7-section-eyebrow" style={{ color: 'var(--v7-neon)' }}>DIGITAL RESOURCES</div>
                <h2 className="v7-section-title" style={{ margin: 0 }}>Get instant access</h2>
              </div>
            </div>
            <div className="v7-reviews-grid">
              {resourceList.map((res, ind) => {
                const isResourceFree = Number(res.amount) === 0;
                const fileCount = res.resourceFiles?.length || 0;
                
                return (
                  <div key={res.id} className="v7-review-card" onClick={() => handleResourceCardClick(res)} style={{ cursor: 'pointer' }}>
                    <div className="v7-section-eyebrow" style={{ color: 'var(--v7-neon)', marginBottom: '16px' }}>
                      RESOURCE {ind + 1} {fileCount > 0 && `· ${fileCount} FILE${fileCount !== 1 ? 'S' : ''}`}
                    </div>
                    <h3 className="v7-service-name" style={{ fontSize: '20px', marginBottom: '8px' }}>{res.serviceName}</h3>
                    <div className="v7-service-price" style={{ marginBottom: '16px', color: 'var(--v7-text)' }}>
                      {isResourceFree ? "Free" : `₹${res.amount}`}
                    </div>
                    <p className="v7-review-text" style={{ fontSize: '14px', opacity: 0.8 }}>{res.description}</p>
                    <button 
                      type="button"
                      className="v7-btn-outline" 
                      style={{ marginTop: 'auto' }}
                      onClick={(e) => { e.stopPropagation(); handleResourceCardClick(res); }}
                    >
                      {isResourceFree ? (
                        <>Download <FiDownload size={14} /></>
                      ) : (
                        <>Purchase <FiLock size={12} /></>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {/* Client Notes (3 Column Grid) */}
        <section className="v7-notes-section">
          <div className="v7-notes-header">
            <div>
              <div className="v7-section-eyebrow">CLIENT NOTES</div>
              <h2 className="v7-section-title" style={{ margin: 0 }}>What clients say about {businessName.split(' ')[0]}</h2>
            </div>
            <div style={{ fontSize: '12px', fontWeight: 600 }}>★★★★★ · {avgRating}</div>
          </div>
          
          <div className="v7-reviews-grid">
            {reviews.slice(0, 3).map((rev, idx) => (
              <div className="v7-review-card" key={idx}>
                <div className="v7-review-stars">
                  {Array.from({ length: Math.round(rev.satisfaction || 5) }).map((_, i) => (
                     <FaStar key={i} size={14} color="var(--v7-neon)" />
                  ))}
                </div>
                <div className="v7-review-text">
                  “{rev.suggestion && rev.suggestion !== "Not given" ? rev.suggestion : "Highly recommended session."}”
                </div>
                <div className="v7-review-author">
                  {rev.name} · {rev.source || "Google"}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* About Provider */}
        <section className="v7-about-section">
          <div className="v7-section-eyebrow">MEET YOUR PROVIDER</div>
          
          {/* Render Professional Name */}
          <h3 className="v7-section-title" style={{ marginBottom: '8px' }}>
            {userDetails.userName || businessName}
          </h3>
          
          {/* Render Profession Details */}
          <p style={{ fontSize: '15px', maxWidth: '480px', lineHeight: 1.6, opacity: 0.8 }}>
            {userDetails.profession?.professionName || "Arjun coaches recreational athletes with a practical eye for durable strength."}
          </p>

          {/* Render Social Media Accounts */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '20px' }}>
            {userDetails.youtube && (
              <a href={userDetails.youtube} target="_blank" rel="noreferrer" style={{ color: 'var(--v7-neon)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaYoutube size={16} /> YouTube
              </a>
            )}
            
            {userDetails.instagram && (
              <a href={userDetails.instagram} target="_blank" rel="noreferrer" style={{ color: 'var(--v7-neon)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaInstagram size={16} /> Instagram
              </a>
            )}
            
            {userDetails.personalWebsite && (
              <a href={userDetails.personalWebsite} target="_blank" rel="noreferrer" style={{ color: 'var(--v7-neon)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaGlobe size={16} /> Website
              </a>
            )}

            {userDetails.faceBook && (
              <a href={userDetails.faceBook} target="_blank" rel="noreferrer" style={{ color: 'var(--v7-neon)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaFacebook size={16} /> Facebook
              </a>
            )}

            {userDetails.linkedIn && (
              <a href={userDetails.linkedIn} target="_blank" rel="noreferrer" style={{ color: 'var(--v7-neon)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaLinkedin size={16} /> LinkedIn
              </a>
            )}
          </div>
          
          {/* Render Specialisations */}
          {eventData.specialisations && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxWidth: '500px', marginTop: '32px' }}>
               {eventData.specialisations.split(',').map((spec, i) => (
                  <span key={i} style={{ border: '1px solid var(--v7-border)', padding: '6px 12px', fontSize: '11px', borderRadius: '20px', fontWeight: 700, textTransform: 'uppercase', color: 'var(--v7-muted)' }}>
                    {spec.trim()}
                  </span>
               ))}
            </div>
          )}
        </section>

        {/* Yuukke Logo Footer */}
        <div className="v7-footer-area">
          <svg width="120" height="30" viewBox="0 0 120 30" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M12.5 5 C10 12 15 20 18 20 C18 10 15 5 12.5 5 Z" fill="#e91e63" />
             <path d="M22 5 C24.5 12 19 20 16 20 C16 10 19 5 22 5 Z" fill="#e91e63" opacity="0.8" />
             <text x="32" y="21" fontFamily="Inter" fontWeight="800" fontSize="18" fill="#111">Yuukke</text>
          </svg>
        </div>
        
        {/* Render Modal last so it overlays everything */}
        {renderBookingModal()}
      </div>
    </div>
  );
};

export default ServiceCardThemeV7;